import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import { auditTrailService } from '../../../lib/auditTrailService';

const SystemChangesPanel = ({ onRefresh }) => {
  const [changes, setChanges] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSystemChanges();
  }, []);

  const loadSystemChanges = async () => {
    setLoading(true);
    try {
      const { data } = await auditTrailService?.getSystemChanges({ limit: 50 });
      setChanges(data || []);
    } catch (error) {
      console.error('Error loading system changes:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-heading font-semibold text-foreground">System Changes</h3>
        <span className="text-sm text-muted-foreground">{changes?.length || 0} changes</span>
      </div>
      <div className="space-y-3">
        {loading ? (
          <div className="text-center py-12">
            <Icon name="Loader" size={32} className="animate-spin text-primary mx-auto" />
          </div>
        ) : changes?.length === 0 ? (
          <div className="text-center py-12">
            <Icon name="Settings" size={48} className="mx-auto mb-4 text-muted-foreground" />
            <p className="text-muted-foreground">No system changes recorded</p>
          </div>
        ) : (
          changes?.map((change) => (
            <div key={change?.id} className="p-4 bg-muted/30 rounded-lg">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-info/10 flex items-center justify-center flex-shrink-0">
                  <Icon name="Settings" size={20} className="text-info" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h4 className="text-sm font-medium text-foreground">{change?.event_action}</h4>
                    <span className="px-2 py-0.5 rounded text-xs font-medium bg-info/15 text-info">
                      {change?.event_category}
                    </span>
                  </div>
                  <p className="text-sm text-muted-foreground mb-2">{change?.event_description}</p>
                  {change?.before_value && change?.after_value && (
                    <div className="mt-2 p-2 bg-background rounded text-xs">
                      <div className="flex items-start gap-2">
                        <span className="text-error">Before:</span>
                        <pre className="text-muted-foreground">{JSON.stringify(change?.before_value, null, 2)}</pre>
                      </div>
                      <div className="flex items-start gap-2 mt-1">
                        <span className="text-success">After:</span>
                        <pre className="text-muted-foreground">{JSON.stringify(change?.after_value, null, 2)}</pre>
                      </div>
                    </div>
                  )}
                  <div className="flex items-center gap-4 text-xs text-muted-foreground mt-2">
                    <span className="flex items-center gap-1">
                      <Icon name="User" size={12} />
                      {change?.user?.full_name || 'System'}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="Clock" size={12} />
                      {new Date(change?.created_at)?.toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SystemChangesPanel;